<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="usuarios"
        :headers="headers"
        :rotina-id="ID_TELA_DE_USUARIOS"
        :configurar="false"
        :loading="loading"
        @create="() => abrirDialogCriarUsuario()"
        @update="(indice) => abrirDialogEditarUsuario(indice)"
        @delete="(indice) => abrirDialogExcluirUsuario(indice)"
      >
        <template #[`item.ativo`]="{ item }">
          <v-icon v-if="item.ativo" color="green">mdi-check</v-icon>
          <v-icon v-else color="red">mdi-close</v-icon>
        </template>
      </DataTableDeCrud>

      <DialogDeEdicaoDeUsuario
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :usuario-param="usuarioParam"
        :itens="itensParam"
        @confirmado="atualizarUsuario"
      />

      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogExcluirUsuario" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="itemUsuarioExclusao">
            Tem certeza que deseja excluir o usuário <b> {{ itemUsuarioExclusao.nome }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogExcluirUsuario = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="excluirUsuario">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import SnackbarMessage from '../../components/SnackbarMessage'
import DialogDeEdicaoDeUsuario from '../../components/usuarios/DialogDeEdicaoDeUsuario'
import DataTableDeCrud from '../../components/DataTableDeCrud'
import SnackBar from '../../models/components/snackbar'
import Usuario from '../../models/usuario'
import UsuarioService from '../../services/usuario/usuario'
import PerfilService from '../../services/usuario/perfil'
import EmpresaService from '@/services/empresa/empresa'
import { ID_TELA_DE_USUARIOS } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeUsuario
  },
  data: () => ({
    name: 'TelaDeUsuarios',
    headers: [
      { text: 'Nome', value: 'nome' },
      { text: 'Login', value: 'login' },
      { text: 'E-mail', value: 'email' },
      { text: 'Status', value: 'ativo' },
      { text: 'Perfil', value: 'perfil.nome' },
      { text: 'Empresa', value: 'empresa.nome' }
    ],
    usuarios: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    usuarioParam: new Usuario(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogExcluirUsuario: false,
    itemUsuarioExclusao: new Usuario(),
    indiceUsuarioExclusao: 0,
    ID_TELA_DE_USUARIOS: ID_TELA_DE_USUARIOS
  }),
  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadUsuarios()
        this.loadPerfis()
        this.loadEmpresas()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar os usuários cadastradas.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadUsuarios() {
      this.loading = true
      const response = await UsuarioService.getAll()
      this.usuarios = response
      this.loading = false
    },

    async loadPerfis() {
      const response = await PerfilService.getAll()
      this.itensPerfil = response.map((item) => ({ text: item.nome, value: item.id }))
    },

    async loadEmpresas() {
      const response = await EmpresaService.getAll()
      this.itensEmpresa = response.map((empresa) => ({
        text: empresa.nome,
        value: empresa.id
      }))
    },

    async excluirUsuario() {
      try {
        await UsuarioService.deleteById(this.itemUsuarioExclusao.id)
        this.snackbar.snackTextParam = 'Usuário removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.usuarios.splice(this.indiceUsuarioExclusao, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogExcluirUsuario = false
    },

    async atualizarUsuario(usuario) {
      if (!usuario) return

      const indice = this.usuarios.findIndex(
        (usuarioExistente) => usuarioExistente.id === usuario.id
      )

      if (indice === -1) {
        this.usuarios.push(usuario)
        this.snackbar.snackTextParam = 'Usuário criado com sucesso.'
      } else {
        this.usuarios.splice(indice, 1, usuario)
        this.snackbar.snackTextParam = 'Usuário atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    abrirDialogCriarUsuario() {
      this.operacao = 'adicionar'
      this.itensParam = { perfil: this.itensPerfil, empresa: this.itensEmpresa }
      this.usuarioParam = new Usuario()
      this.showDialogParam = true
    },

    abrirDialogEditarUsuario(indice) {
      this.operacao = 'editar'
      this.itensParam = { perfil: this.itensPerfil, empresa: this.itensEmpresa }
      this.usuarioParam = { ...this.usuarios[indice] }
      this.showDialogParam = true
    },

    abrirDialogExcluirUsuario(indice) {
      this.itemUsuarioExclusao = this.usuarios[indice]
      if (!this.itemUsuarioExclusao.id) return

      this.indiceUsuarioExclusao = indice
      this.dialogExcluirUsuario = true
    }
  }
}
</script>
